import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Price from 'Components/Utility/Price/Price';
import { currencyCode } from 'Helpers/Geo/data';

function PackEditionSelector({ packs, slug }) {
  if (packs.length <= 1) return false;

  return (
    <React.Fragment>
      <div
        className={classNames(
          'product-edition-selector',
          { 'two-editions': packs.length === 2 },
          { 'three-editions': packs.length === 3 },
          { 'four-editions': packs.length === 4 },
        )}
      >
        {packs.sort((a, b) => a.quantity - b.quantity).map((pack) => {
          const currentPrice = pack.currentPrice;

          return (
            <Link key={pack.slug} to={`/${pack.type}/${pack.slug}`} className={classNames('edition-container', { active: pack.slug === slug })}>
              <div className="edition">
                <div className="edition-name">
                  {pack.quantity === 1 ?
                    <FormattedMessage id="pack-edition.single" defaultMessage="Single" />
                    :
                    <FormattedMessage id="pack-edition.pack" defaultMessage="{packQuantity} Pack" values={{ packQuantity: pack.quantity }} />
                  }
                </div>
                <div className="prices-container">
                  <span className={classNames('current-price', { active: pack.slug === slug })}>
                    <strong>
                      <Price price={currentPrice} />
                    </strong>
                  </span>
                  {pack.price[currencyCode] !== currentPrice[currencyCode] &&
                    <span className="full-price">
                      <Price price={pack.price} />
                    </span>
                  }
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </React.Fragment>
  );
}

PackEditionSelector.propTypes = {
  packs: PropTypes.arrayOf(PropTypes.shape({})),
  slug: PropTypes.string,
};

PackEditionSelector.defaultProps = {
  packs: [],
  slug: '',
};

export default PackEditionSelector;
